// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7b31aa45390059a7b13c","655":"5761ba8ed6752041e89f"}[chunkId] + ".js";
};